import { chunk, map, size } from 'lodash/fp';

import { CustomService } from '../format-data-for-content-tile/types';
import { TILE_VARIANTS } from '../../../../../ahm-constants/ui';
import formatDataForContentTile from '../format-data-for-content-tile';

const { FULL_WIDTH, HORIZONTAL, VERTICAL_CENTER } = TILE_VARIANTS;

// @ts-expect-error - Automatic, Please fix when editing this file
const groupRowDataByVariant = ({ amountOfCenteredRows, amountOfLeftAlignedRows, chunksOfTiles }) =>
  // @ts-expect-error - Automatic, Please fix when editing this file
  map.convert({ cap: false })((tileChunk, index) => {
    const rowNumber = index + 1;
    const totalHalfTiles = amountOfLeftAlignedRows + amountOfCenteredRows;

    const halfLeftAlignedType = rowNumber <= amountOfLeftAlignedRows ? HORIZONTAL : null;
    const halfCenterAlignedType =
      rowNumber > amountOfLeftAlignedRows && rowNumber <= totalHalfTiles ? VERTICAL_CENTER : null;

    const variantType = halfLeftAlignedType || halfCenterAlignedType || FULL_WIDTH;
    return map((tileData) => ({ ...tileData, variant: variantType }), tileChunk);
  })(chunksOfTiles);

/**
 * This function takes in mediumImportanceChildTerms and marketingOrSalesCTA objects, combines and formats the data to render out content tile components.
 * Depending on the row number, the variant for each particular row will change. The rows will be split into two, and if there is an uneven amount of rows the extra row
 * will be set to be the left aligned variant, unless its a single row (of two tiles). If there is an uneven amount of tiles the last row will be full width.
 */

const getContentTilesData = ({ serviceTiles }: { serviceTiles?: CustomService[] }) => {
  const formattedTileData = formatDataForContentTile({ serviceTiles });
  const isEvenAmountOfTiles = formattedTileData.length % 2 === 0;
  const chunksOfTiles = chunk(2, formattedTileData);

  // subtract a row if uneven amount of tiles, so the last row is full width variant
  const rowsAmount = isEvenAmountOfTiles ? size(chunksOfTiles) : size(chunksOfTiles) - 1;
  const unevenAmountOfRows = rowsAmount % 2;

  // to get an even amount when halving an uneven amount, remove the uneven amount of rows
  const halfRowsAmount = (rowsAmount - unevenAmountOfRows) / 2;
  const leftAlignedAmount = unevenAmountOfRows ? halfRowsAmount + 1 : halfRowsAmount;
  const hasSingleCenterAlignedRow = rowsAmount === 1;

  return groupRowDataByVariant({
    amountOfCenteredRows: hasSingleCenterAlignedRow ? 1 : halfRowsAmount,
    amountOfLeftAlignedRows: hasSingleCenterAlignedRow ? 0 : leftAlignedAmount,
    chunksOfTiles,
  });
};

export default getContentTilesData;
